import { useInstructorClasses } from 'modules/instrutor/classes/useInstructorClasses';
import { useAuth } from 'shared/hooks/useAuth';
import { ClassGroupRow } from 'modules/arena/class-groups/components/ClassGroupRow';
import { ClassGroupDetailPanel } from 'modules/arena/class-groups/components/ClassGroupDetailPanel';
import { AsyncSection } from 'shared/components/ui/LoadingState';
import { SkeletonListDetail } from 'shared/components/ui/Skeleton';

export function InstructorClassesPage() {
  const { user } = useAuth();
  const {
    myGroups,
    isLoading,
    error,
    selectedId,
    setSelectedId,
    selectedGroup,
    expandedSessionId,
    toggleExpandSession,
    togglePresence,
    saveAttendance,
  } = useInstructorClasses();

  return (
    <section className="mx-auto max-w-5xl px-4 py-8">
      <h1 className="font-heading text-xl font-bold text-ink">Minhas Turmas</h1>
      <p className="text-sm text-ink-secondary">
        {user?.name} · consulte suas turmas, alunos matriculados e registre presença.
      </p>

      <AsyncSection
        isLoading={isLoading}
        error={error}
        loadingLabel="Carregando turmas..."
        skeleton={
          <>
            <SkeletonListDetail rows={2} lines={3} className="mt-6" />
          </>
        }
      >
        {myGroups.length === 0 ? (
          <p className="mt-6 text-sm text-ink-secondary">Nenhuma turma vinculada a este instrutor.</p>
        ) : (
          <div className="mt-6 grid gap-6 lg:grid-cols-[1.1fr_1fr]">
            <div className="flex flex-col gap-3">
              {myGroups.map((group) => (
                <ClassGroupRow
                  key={group.id}
                  group={group}
                  isSelected={group.id === selectedId}
                  onSelect={setSelectedId}
                />
              ))}
            </div>

            <div className="lg:sticky lg:top-6 lg:self-start">
              {selectedGroup && (
                <ClassGroupDetailPanel
                  group={selectedGroup}
                  expandedSessionId={expandedSessionId}
                  onToggleExpandSession={toggleExpandSession}
                  onTogglePresence={togglePresence}
                  onSaveAttendance={saveAttendance}
                  canManage={false}
                />
              )}
            </div>
          </div>
        )}
      </AsyncSection>
    </section>
  );
}
